<template>
  <div v-loading.lock.body="loading" class="render">
    <iframe
      v-if="url"
      :src="url"
      width="100%"
      height="100%"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
      allowtransparency="yes"
    />
    <pb-result
      v-else
      icon="404"
      :title="
        $t('Gattaran_lowcode_axmA_FvoV') /** 未获取到页面的URL，请点击重试或联系平台管理员处理 */
      "
      class="result"
    >
      <template slot="extra">
        <pb-button type="primary" size="medium" @click="reload">
          {{ $t('FoodD_one_Try_again_qZka' /**重试 */) }}
        </pb-button>
      </template>
    </pb-result>
  </div>
</template>
<script>
export default {
  name: 'Ifreame',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.render {
  height: 100%;
  overflow: hidden;
  .result {
    margin: 16px;
    background: #fff;
    height: 100%;
    ::v-deep .pb-result__icon {
      svg {
        width: 256px;
        height: 256px;
      }
    }
    ::v-deep .pb-result__title {
      font-size: 24px;
    }
  }
}
</style>
